export default "__VITE_ASSET__CNK9migD__"